export default "__VITE_ASSET__DizCXzBa__"